/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Data related to session wallet
 */

// required attributes
const SessionWalletRetrieveResponseR = t.interface({
  orderId: t.string,

  walletId: t.string,

  isFinalOutcome: t.boolean
});

// optional attributes
const SessionWalletRetrieveResponseO = t.partial({
  outcome: t.number
});

export const SessionWalletRetrieveResponse = t.intersection(
  [SessionWalletRetrieveResponseR, SessionWalletRetrieveResponseO],
  "SessionWalletRetrieveResponse"
);

export type SessionWalletRetrieveResponse = t.TypeOf<
  typeof SessionWalletRetrieveResponse
>;
